import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Button} from "primereact/button";
import {useRef} from "react";
import axios from "axios";

const ImportFormComponent = (props) => {

  const {t, view} = props;
  const history = useHistory();
  const {module, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [fileUploading, setFileUploading] = useState(false);
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [fileUploadError, setFileUploadError] = useState(null);
  const fileUploadRef = useRef(null);
  const [type, setType] = useState('');
  const [relatedId, setRelatedId] = useState('');

  const uploadImportNow = async (navigateBack = false) => {
    if (!selectedFile) return;
    setFileUploadError(null);
    setFileUploading(true);
    setFileUploadProgress(0);
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);
      await axios.post(
        process.env.REACT_APP_API_HOST + "/api/v2/import-upload/" + type + relatedId,
        formData,
        {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId"),
          },
          onUploadProgress: (evt) => {
            if (!evt.total) return;
            const percent = Math.round((evt.loaded * 100) / evt.total);
            setFileUploadProgress(percent);
          }
        }
      );
      window.App.setState({rerenderImportList: Math.random()});
      window.App.toastShow('success', 'Sikeres importálás!');
      fileUploadRef.current?.clear();
      setSelectedFile(null);
      if (navigateBack) {
        history.push(props.backlink);
      }
    } catch (error) {
      const msg = error?.response?.data?.detail || error?.response?.data?.message || error.toString();
      setFileUploadError(msg);
      window.App.toastShow('error', t('error'), msg, '', error.response);
    } finally {
      setFileUploading(false);
      setLoading(false);
    }
  };

  const downloadImportTemplate = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_HOST + (props.templateUrl || "/api/v2/material/import-template"),
        {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId"),
          },
          responseType: 'blob'
        }
      );
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', props.templateFilename || 'material_import_template.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      const msg = error?.response?.data?.detail || error?.response?.data?.message || error.toString();
      window.App.toastShow('error', t('error'), msg, '', error.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.importType) {
      setType(props.importType);
    }
    if (!props.importType) {
      if (module === 'crm') {
        setType('crm_action');
      }
      if (module === 'procurement') {
        setType('purchase_order_request');
      }
      if (module === 'inventory') {
        setType('material');
      }
    }
    if (props.relatedEntityId) {
      setRelatedId('?relatedEntityId=' + props.relatedEntityId)
    }
    if (!props.relatedEntityId && id) {
      setRelatedId('?relatedEntityId=' + id)
    }
  }, [])

  return (
    <>
      {loading &&
        <ProgressBar mode="indeterminate"
          style={{height: '5px', position: "absolute", top: 0, left: 0, right: 0, borderRadius: 0}} />
        }
        
      {(props.view === 'inventory' || props.templateUrl) &&
          <Button
            type="button"
            icon="pi pi-download"
            className="p-mb-3"
            style={{ width: 'auto', whiteSpace: 'nowrap' }}
            disabled={loading || fileUploading}
            onClick={downloadImportTemplate}
          >
            &nbsp;

            {props.t('downloadTemplateFile')} 
          </Button>
        }

      {type === 'partner' && <div className="p-message p-message-info p-mb-3">
        <span className="p-message-icon pi pi-info-circle"/>
        <div className="p-message-wrapper">
          <b>{t('partnerExternalImport')}</b><br/>
          <span>{t('partnerExternalImportHint')}</span><br/>
          <small>FILL_EMPTY: csak az üres mezőket tölti · OVERWRITE: felülírja a meglévő adatokat · SKIP: egyezés esetén kihagyja a sort.</small>
        </div>
      </div>}


      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6 p-xl-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="file" className="p-d-block">{props.t('fieldFile')}</label>
            <span className="p-d-block">
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const f = e.target.files?.[0] || null;
                    setSelectedFile(f);
                    e.target.value = null;
                  }}
                  disabled={loading || fileUploading}
                />
                <Button
                  type="button"
                  className="p-button"
                  style={{ width: 'auto', whiteSpace: 'nowrap' }}
                  disabled={loading || fileUploading}
                  onClick={() => fileInputRef.current?.click()}
                >
                  <i className="pi pi-plus" />
                  &nbsp;
                  {fileUploading ? props.t('uploading') : (selectedFile?.name || props.t('chooseFile'))}
                </Button>
              </span>
          </div>
        </div>
      </div>
      <div className={"p-grid p-mt-1"}>
        <div className={"p-col-12 p-lg-6 p-xl-6"} />
        <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
          <Button
            type="button"
            label={t('save')}
            loading={loading || fileUploading}
            icon="pi pi-save"
            className="p-button-success p-ml-2"
            disabled={!selectedFile || loading || fileUploading}
            onClick={() => {
              uploadImportNow(false);
            }}
          />
          <Button
            type="button"
            label={t('saveAndBack')}
            loading={loading || fileUploading}
            icon="pi pi-arrow-left"
            className="p-button-success p-ml-2"
            disabled={!selectedFile || loading || fileUploading}
            onClick={() => {
              uploadImportNow(true);
            }}
          />
        </div>
      </div>
    </>
  )
}
export default withTranslation('common')(ImportFormComponent);
